<template>
  <div id="VodEnvTest">
    <el-row class="top-title">
      <el-col :span="24" class="top-title">
        <h2>直播环境配置检测</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="testItem" label="测试项"></el-table-column>
        <el-table-column label>
          <template slot-scope="scope">
            <span v-if="scope.row.tips != '正在检测...'">
              <i class="el-icon-circle-check success" v-if="scope.row.flag"></i>
              <i class="el-icon-circle-close failure" v-else></i>
            </span>
            <span v-html="scope.row.tips"></span>
          </template>
        </el-table-column>
        <el-table-column label>
          <template slot-scope="scope">
            <span v-if="scope.row.tips1 != '正在检测...'">
              <i class="el-icon-circle-check success" v-if="scope.row.flag1"></i>
              <i class="el-icon-circle-close failure" v-else></i>
              <span v-html="scope.row.tips1"></span>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'

import { $Url } from '../plugins/utils'

export default {
  name: 'VodEnvTest',
  data() {
    return {
      inTesting: '正在检测...',
      tableData: [
        {
          testItem: '阿里拉流/低延迟',
          url: '://pull-d1.videocc.net',
          tips: '正在检测...',
          tips1: '正在检测...'
        },
        {
          testItem: '阿里拉流/高缓存',
          url: '://pull-c1.videocc.net',
          tips: '正在检测...',
          tips1: '正在检测...'
        },
        {
          testItem: '网宿拉流',
          url: '://pull.videocc.net',
          tips: '正在检测...',
          tips1: '正在检测...'
        },
        {
          testItem: '聊天室1',
          url:
            'wss://chat.polyv.net/socket.io/?version=2.0&token=0eb9b9d321714e02bfe7eb87e428d251&EIO=3&transport=websocket',
          tips: '正在检测...',
          tips1: '正在检测...'
        },
        {
          testItem: '聊天室2',
          url:
            '://apichat.polyv.net/front/history?callback=jQuery112306353992136874995_1580870366132&roomId=128054&start=0&end=10&toGetSubRooms=true&_=1580870366133',
          tips: '正在检测...',
          tips1: '正在检测...'
        },
        {
          testItem: '播放器',
          url: '://player.polyv.net',
          tips: '正在检测...',
          tips1: '正在检测...'
        }
      ]
    }
  },
  methods: {
    pull() {
      for (let i = 0; i < 3; i++) {
        Vue.axios
          .get('http' + this.tableData[i].url)
          .then(() => {
            // console.log(resp)
                          let data = this.tableData[i]
              data.tips = 'HTTP连接成功'
              data.flag = true
              Vue.set(this.tableData, i, data)
          })
          .catch(resp => {
            if (resp.response.status == 403) {
              let data = this.tableData[i]
              data.tips = 'HTTP连接成功'
              data.flag = true
              Vue.set(this.tableData, i, data)
            } else {
              let data = this.tableData[i]
              data.tips = 'HTTP连接失败'
              data.flag = false
              Vue.set(this.tableData, i, data)
            }
          })

        Vue.axios
          .get('https' + this.tableData[i].url)
          .then(() => {
            // console.log(resp)
                          let data = this.tableData[i]
              data.tips1 = 'HTTP连接成功'
              data.flag1 = true
              Vue.set(this.tableData, i, data)
          })
          .catch(resp => {
            if (resp.response.status == 403) {
              let data = this.tableData[i]
              data.tips1 = 'HTTPS连接成功'
              data.flag1 = true
              Vue.set(this.tableData, i, data)
            } else {
              let data = this.tableData[i]
              data.tips1 = 'HTTPS连接失败'
              data.flag1 = false
              Vue.set(this.tableData, i, data)
            }
          })
      }
    },
    playerTest() {
      Vue.axios
        .get('http' + this.tableData[5].url)
        .then(() => {
          let data = this.tableData[5]
          data.tips = 'HTTPS连接成功'
          data.flag = true
          Vue.set(this.tableData, 5, data)
        })
        .catch(resp => {
          if (resp.response.status == 403) {
            let data = this.tableData[5]
            data.tips = 'HTTPS连接成功'
            data.flag = true
            Vue.set(this.tableData, 5, data)
          } else {
            let data = this.tableData[5]
            data.tips = 'HTTPS连接失败'
            data.flag = false
            Vue.set(this.tableData, 5, data)
          }
        })
    },
    chartRoom1() {
      var ws = new WebSocket(
        'wss://chat.polyv.net/socket.io/?version=2.0&token=0eb9b9d321714e02bfe7eb87e428d251&EIO=3&transport=websocket'
      )
      ws.onopen = () => {
        let data = this.tableData[3]
        data.tips = 'WSS连接成功'
        data.flag = true
        Vue.set(this.tableData, 3, data)
      }
      ws.onerror = () => {
        let data = this.tableData[3]
        data.tips = 'WSS连接失败'
        data.flag = false
        Vue.set(this.tableData, 3, data)
      }
    },
    chartRoom2() {
      $Url('http' + this.tableData[4].url)
        .then(() => {
          let data = this.tableData[4]
          data.tips = 'HTTP连接成功'
          data.flag = true
          Vue.set(this.tableData, 4, data)
        })
        .catch(() => {
          let data = this.tableData[4]
          data.tips = 'HTTP失败'
          data.flag = false
          Vue.set(this.tableData, 4, data)
        })
      $Url('https' + this.tableData[4].url)
        .then(() => {
          let data = this.tableData[4]
          data.tips1 = 'HTTPS连接成功'
          data.flag1 = true
          Vue.set(this.tableData, 4, data)
        })
        .catch(() => {
          let data = this.tableData[4]
          data.tips1 = 'HTTPS连接失败'
          data.flag1 = false
          Vue.set(this.tableData, 4, data)
        })
    }
  },
  mounted() {
    this.chartRoom1()
    this.chartRoom2()
    this.pull()
  }
}
</script>
<style>
h2 {
  color: white;
}
.success {
  color: #67c23a;
  font-size: 25px;
}
.failure {
  color: red;
  font-size: 25px;
}
</style>>